import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { LegalEntityData } from 'chaika-frontend-types/frontend-cms';

import { legalEntityQueryOptions } from '@organization/queries/legalEntityQueries';

// id -> entity map for display lookups (names, currency); dupes/undefined ids are normalized.
// Display-only: loading, error, and absent all collapse to `map.get(id) === undefined`.
// Need the fetch status too (e.g. to gate an action)? Use `useLegalEntityMapQuery`.
export function useLegalEntityMapQuery(ids: string[]): { map: Map<string, LegalEntityData>; isFetched: boolean } {
    const { data = [], isFetched } = useQuery(legalEntityQueryOptions.byIds(ids));
    const map = useMemo(() => new Map(data.map(le => [le.id, le] as const)), [data]);

    return { map, isFetched };
}

export function useLegalEntityMap(ids: string[]): Map<string, LegalEntityData> {
    return useLegalEntityMapQuery(ids).map;
}
